var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base-desc-root-container"},[_c('span',{staticClass:"base-desc-title"},[_vm._v("项目描述")]),_c('p',[_vm._v(_vm._s(_vm.dataSource.more))])])}
var staticRenderFns = []

export { render, staticRenderFns }